// Utility to generate quotation IDs in format QT-YYYY-XXXXXX
// Example: QT-2026-123456
export function generateQuotationId() {
  const now = new Date();
  const year = now.getFullYear();
  const seq = String(Date.now()).slice(-6);
  return `QT-${year}-${seq}`;
}

export default generateQuotationId;
